import React, { useState } from "react";
import classes from "./Contact.module.css";
import translate from "../../service/Language";
import axios from "axios";
import { toast } from "react-toastify";

function Contact() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const URI_API = `https://api.telegram.org/bot${process.env.REACT_APP_TOKEN}/sendMessage`;

  const SendToTelegram = () => {
    let message = `<b>MEHRIBONSHOP.UZ</b>\n\n`;
    message += `<b>Consultatsiya olmoqchi!</b>\n`;
    message += `<b>Ismi: </b> ${name}\n`;
    message += `<b>Telefon raqami: </b> ${phone}\n`;
    message += `<b>Vaqt: </b> ${new Date().toLocaleDateString()}`;

    axios
      .post(URI_API, {
        chat_id: process.env.REACT_APP_CHAT_ID,
        parse_mode: "html",
        text: message,
      })
      .then((res) => {
        setName("");
        setPhone("");
      })
      .catch((err) => { })
      .finally(() => {
        setName("");
        setPhone("");
        toast.success(translate("Отправлен!", "Yuborildi!"))
      });
  };

  return (
    <div className={classes.Contacts} id="contact">
      <h2>{translate("ДЛЯ СВЯЗИ", "MULOQOT UCHUN")}</h2>
      <div className={classes.Contact}>
        <div className={classes.Left}>
          <a href="tel:+998 88 333 95 94" className={classes.phone}>
            +998 88 333 95 94
          </a>
          <div className={classes.socials}>
            <a href="https://www.facebook.com/profile.php?id=100088408083574">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
                width="30px"
                height="30px"
              >
                <path d="M15,3C8.373,3,3,8.373,3,15c0,6.016,4.432,10.984,10.206,11.852V18.18h-2.969v-3.154h2.969v-2.099c0-3.475,1.693-5,4.581-5 c1.383,0,2.115,0.103,2.461,0.149v2.753h-1.97c-1.226,0-1.654,1.163-1.654,2.473v1.724h3.593L19.73,18.18h-3.106v8.697 C22.481,26.083,27,21.075,27,15C27,8.373,21.627,3,15,3z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/mehribon__shop/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
                width="30px"
                height="30px"
              >
                <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z" />
              </svg>
            </a>
            <a href="https://t.me/Tumilichacho">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50"
                width="29px"
                height="29px"
              >
                <path d="M25,2c12.703,0,23,10.297,23,23S37.703,48,25,48S2,37.703,2,25S12.297,2,25,2z M32.934,34.375	c0.423-1.298,2.405-14.234,2.65-16.783c0.074-0.772-0.17-1.285-0.648-1.514c-0.578-0.278-1.434-0.139-2.427,0.219	c-1.362,0.491-18.774,7.884-19.78,8.312c-0.954,0.405-1.856,0.847-1.856,1.487c0,0.45,0.267,0.703,1.003,0.966	c0.766,0.273,2.695,0.858,3.834,1.172c1.097,0.303,2.346,0.04,3.046-0.395c0.742-0.461,9.305-6.191,9.92-6.693	c0.614-0.502,1.104,0.141,0.602,0.644c-0.502,0.502-6.38,6.207-7.155,6.997c-0.941,0.959-0.273,1.953,0.358,2.351	c0.721,0.454,5.906,3.932,6.687,4.49c0.781,0.558,1.573,0.811,2.298,0.811C32.191,36.439,32.573,35.484,32.934,34.375z" />
              </svg>
            </a>
          </div>
        </div>
        <div className={classes.Right}>
          <form
            action="GET"
            onSubmit={(e) => {
              e.preventDefault();
              SendToTelegram();
            }}
          >
            <input
              type="text"
              name=""
              id=""
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={translate("Ваше имя", "Ismingiz")}
              required
            />
            <input
              type="number"
              name=""
              id=""
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder={translate(
                "Ваш номер телефона",
                "Telefon raqamingiz"
              )}
              minLength={8}
              required
            />
            <button type="submit">
              {translate("Получить консультацию", "Batafsil ma'lumot olish")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
